export const markerType = {
    NONE: 'initiativeArea',
    DRINKINGFOUNTAINS: 'drinkingFountains',
    PARKING: 'parking',
    REPAIRING_STATION: 'repairingStation',
    REPORT: 'publicUtilityRecord',
}